<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import AgenteIaAPI from 'dashboard/api/agenteIa';

const { t } = useI18n();
const oferta = ref(null);
const carregando = ref(true);
const enviando = ref('');

const carregar = async () => {
  carregando.value = true;
  const { data } = await AgenteIaAPI.oferta();
  oferta.value = data;
  carregando.value = false;
};

onMounted(carregar);

const moeda = valor =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    valor || 0
  );

const pedidoPendente = computed(() =>
  oferta.value?.pedidos_pendentes?.find(pedido => pedido.tipo === 'modulo')
);

const pedir = async plano => {
  enviando.value = plano;
  try {
    const { data } = await AgenteIaAPI.pedir('modulo', plano);
    oferta.value = { ...oferta.value, pedidos_pendentes: data.pedidos };
  } finally {
    enviando.value = '';
  }
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-y-auto bg-n-background">
    <div class="flex flex-col w-full max-w-4xl gap-6 px-4 py-6 mx-auto sm:px-6">
      <header class="flex flex-col gap-1">
        <h1 class="text-xl font-medium text-n-slate-12">
          {{ t('AGENTE_IA.OFERTA.TITULO') }}
        </h1>
        <p class="text-sm text-n-slate-11">
          {{ t('AGENTE_IA.OFERTA.DESCRICAO') }}
        </p>
      </header>

      <p v-if="carregando" class="text-sm text-n-slate-11">
        {{ t('AGENTE_IA.CARREGANDO') }}
      </p>

      <template v-else-if="oferta?.ativa">
        <p v-if="pedidoPendente" class="text-sm text-n-teal-11">
          {{ t('AGENTE_IA.OFERTA.PEDIDO_ENVIADO') }}
        </p>
        <div v-else class="grid gap-4 sm:grid-cols-2">
          <div
            v-for="plano in ['agente', 'agente_avancado']"
            :key="plano"
            class="flex flex-col gap-2 p-4 border rounded-lg border-n-weak"
          >
            <h2 class="text-sm font-medium text-n-slate-12">
              {{ t(`AGENTE_IA.PLANOS.${plano.toUpperCase()}`) }} —
              {{ moeda(oferta.planos[plano]?.preco) }}
            </h2>
            <ul class="text-sm list-disc list-inside text-n-slate-11">
              <li
                v-for="destaque in oferta.planos[plano]?.destaques"
                :key="destaque"
              >
                {{ destaque }}
              </li>
            </ul>
            <button
              class="self-start button"
              :disabled="enviando === plano"
              @click="pedir(plano)"
            >
              {{
                t(
                  plano === 'agente'
                    ? 'AGENTE_IA.OFERTA.QUERO_O_AGENTE'
                    : 'AGENTE_IA.OFERTA.QUERO_O_AVANCADO'
                )
              }}
            </button>
          </div>
        </div>

        <p
          v-if="oferta.contato?.email || oferta.contato?.whatsapp"
          class="text-xs text-n-slate-11"
        >
          {{ t('AGENTE_IA.PLANO.CONTATO') }}
          <span v-if="oferta.contato.email">{{ oferta.contato.email }}</span>
          <span v-if="oferta.contato.whatsapp">
            · {{ oferta.contato.whatsapp }}</span
          >
        </p>
      </template>

      <p v-else class="text-sm text-n-slate-11">
        {{ t('AGENTE_IA.OFERTA.INDISPONIVEL') }}
      </p>
    </div>
  </section>
</template>
